module.exports = __webpack_public_path__ + "img/VIP-7.40e0c2a5.png";